import { ValueOf } from 'type-fest';

import { css, keyframes, theme } from '../stitches.config';
import { rem, Scale } from '../util';

type Color = ValueOf<typeof theme.colors>;

export const Spinner = ({ color, size }: { size: Scale; color?: Color }) => {
  const strokeWidth = 2;
  const r = size / 2 - strokeWidth;
  const cx = size / 2;
  const cy = size / 2;

  return (
    <svg
      className={spinnerStyles({
        css: { width: rem(size), height: rem(size) },
      })}
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        d={`
          M ${cx - r}, ${cy}
          a ${r},${r} 0 1,0 ${r * 2},0
        `}
        fill="transparent"
        stroke={color?.value ?? 'currentColor'}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

const rotate = keyframes({
  from: { transform: 'rotate(0deg)' },
  to: { transform: 'rotate(360deg)' },
});

const spinnerStyles = css({
  animation: `${rotate} 1.1s infinite linear`,
});
